// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { FavoritesProvider } from './contexts/FavoritesContext';
import Home from './pages/Home';
import Product from './pages/Product';
import Products from './pages/Products';
import Cart from './pages/Cart';
import Categories from './pages/Categories';
import Favorites from './pages/Favorites';
import Profile from './pages/Profile';
import Login from './pages/Login';
import Checkout from './pages/Checkout';
import OrderDetails from './pages/OrderDetails';
import AdminDashboard from './pages/Admin/Dashboard';
import AdminProducts from './pages/Admin/Products';
import AdminOrders from './pages/Admin/Orders';
import AdminOrderDetails from './pages/Admin/OrderDetails';
import ShippingManagement from './pages/Admin/ShippingManagement';
import Layout from './components/Common/Layout';
import ErrorBoundary from './components/Common/ErrorBoundary';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import ScrollToTop from './components/Common/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ErrorBoundary>
        <AuthProvider>
          <CartProvider>
            <FavoritesProvider>
              <Layout>
                <Routes>
                  {/* Department routes */}
                  <Route path="/department/men" element={<Home department="الرجال" />} />
                  <Route path="/department/women" element={<Home department="النساء" />} />
                  <Route path="/department/children" element={<Home department="الأطفال" />} />
                  
                  {/* Category routes within departments */}
                  <Route path="/department/men/:category" element={<Products />} />
                  <Route path="/department/women/:category" element={<Products />} />
                  <Route path="/department/children/:category" element={<Products />} />
                  
                  {/* Default redirect to children's department */}
                  <Route path="/" element={<Navigate to="/department/children" replace />} />
                  
                  {/* Other public routes */}
                  <Route path="/product/:id" element={<Product />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/categories" element={<Categories />} />
                  
                  {/* Protected user routes */}
                  <Route element={<ProtectedRoute />}>
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/favorites" element={<Favorites />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/order/:id" element={<OrderDetails />} />
                  </Route>
                  
                  {/* Admin routes */}
                  <Route element={<ProtectedRoute adminOnly />}>
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    <Route path="/admin/products" element={<AdminProducts />} />
                    <Route path="/admin/orders" element={<AdminOrders />} />
                    <Route path="/admin/order/:id" element={<AdminOrderDetails />} />
                    <Route path="/admin/shipping" element={<ShippingManagement />} />
                  </Route>
                  
                  {/* 404 fallback */}
                  <Route path="*" element={<Navigate to="/department/children" replace />} />
                </Routes>
              </Layout>
            </FavoritesProvider>
          </CartProvider>
        </AuthProvider>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
